import Modal from "./Modal";

export default function Confirm({ callback, onCancel, children }) {
    return (
        <Modal closeCallback={onCancel}>
            <div>
                {children}<br/><br/>
                <button className="modal__button" onClick={callback} autoFocus>Confirm</button>
                <button className="modal__button" onClick={onCancel} style={{"float":"right"}}>Cancel</button>
            </div>
        </Modal>
    )
}